const cards = [
  {
    title: '长安十二时辰',
    desc: '雷佳音、易烊千玺主演古装悬疑巨制，4K修复版画质震撼，剧情环环相扣引人入胜。',
    tag: '热播剧集',
    img: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20cinematic%20scene%20ancient%20city%20at%20night%20warm%20lantern%20lights%20dark%20atmosphere%20epic%20scale%20artistic%20composition%20no%20text%20no%20people&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    title: '流浪地球3',
    desc: '中国科幻电影巅峰之作，宏大的宇宙叙事与震撼特效，带你领略人类命运的壮丽史诗。',
    tag: '院线大片',
    img: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20cinematic%20scene%20giant%20planet%20in%20space%20warm%20orange%20atmosphere%20dramatic%20lighting%20cosmic%20scale%20artistic%20composition%20no%20text&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    title: '这！就是街舞7',
    desc: '顶级舞者热血对决，全新赛制升级，每期都有炸裂舞台表演，综艺迷不可错过。',
    tag: '热门综艺',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20stage%20performance%20abstract%20visual%20vibrant%20energy%20spotlight%20beams%20dark%20background%20artistic%20motion%20cinematic%20style%20no%20text&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    title: '霸王别姬',
    desc: '张国荣经典之作4K修复版，华语电影不可逾越的高峰，每一帧都是艺术的极致表达。',
    tag: '经典修复',
    img: 'https://readdy.ai/api/search-image?query=Classic%20Chinese%20opera%20cinematic%20abstract%20visual%20warm%20nostalgic%20tones%20dramatic%20stage%20lighting%20dark%20atmosphere%20elegant%20artistic%20composition%20no%20text&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    title: '狂飙',
    desc: '张译、张颂文演技炸裂，年度现象级犯罪剧情剧，豆瓣9.5分口碑封神之作。',
    tag: '口碑神剧',
    img: 'https://readdy.ai/api/search-image?query=Crime%20drama%20cinematic%20abstract%20visual%20dark%20urban%20night%20scene%20warm%20street%20lights%20moody%20atmosphere%20film%20noir%20aesthetic%20artistic%20composition%20no%20text&width=600&height=400&seq=card-05&orientation=landscape',
  },
  {
    title: '庆余年2',
    desc: '张若昀领衔古装权谋大剧续作，原班人马回归，剧情更加扑朔迷离扣人心弦。',
    tag: '热播剧集',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20cinematic%20abstract%20visual%20warm%20golden%20light%20grand%20architecture%20dark%20mysterious%20atmosphere%20artistic%20composition%20no%20text&width=600&height=400&seq=card-06&orientation=landscape',
  },
  {
    title: '繁花',
    desc: '王家卫首部电视剧，胡歌主演的上海滩风云，光影美学与时代记忆的完美交织。',
    tag: '品质剧集',
    img: 'https://readdy.ai/api/search-image?query=Retro%20Shanghai%20cinematic%20abstract%20visual%20warm%20nostalgic%20neon%20lights%20rainy%20street%20dark%20atmosphere%20elegant%20artistic%20composition%20no%20text&width=600&height=400&seq=card-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="relative py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-50 mb-3">精选推荐</h2>
          <p className="text-foreground-500 max-w-lg mx-auto">编辑精选优质内容，发现值得观看的好片好剧</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, idx) => (
            <div key={idx} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/50 hover:border-primary-500/20 transition-all duration-300 cursor-pointer">
              <div className="relative h-48 md:h-52 overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-background-950/70 text-primary-400 text-xs font-medium backdrop-blur-sm">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-foreground-100 font-semibold text-base md:text-lg mb-2">{card.title}</h3>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}